exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel-option button {\n  color: red;\n  background-color: white;\n}\n.panel-option button ,.panel-option button:active:focus,\n.panel-option button:hover, .panel-option button:active,\n.panel-option .btn:not(:disabled):not(.disabled):active{\n  color: inherit;\n  background-color: inherit;\n  border: none;\n  box-shadow: none;\n  padding: 5px 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07e6a3b4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/settings/confidenceColors.vue
// module id = 1314
// module chunks = 2